
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/holidaypackage/holiday-details",
      function () {
        return require("private-next-pages/holidaypackage/holiday-details.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/holidaypackage/holiday-details"])
      });
    }
  